import {O} from "web-vcore";
import {Tool_Cursor, ToolState_Cursor} from "../../../UI/Maps/MapUI/Toolbox/Tools/Cursor.js";
import {Tool_Select, ToolState_Select} from "../../../UI/Maps/MapUI/Toolbox/Tools/Select.js";
import {Tool_Move, ToolState_Move} from "../../../UI/Maps/MapUI/Toolbox/Tools/Move.js";
import {MapTool, Tool} from "../../../UI/Maps/MapUI/Toolbox/Tools/@Tool.js";
import {Tool_AddObject, ToolState_AddObject} from "../../../UI/Maps/MapUI/Toolbox/Tools/AddObject.js";
import {store} from "../../index.js";
import {Tool_MeshModify, ToolState_MeshModify} from "../../../UI/Maps/MapUI/Toolbox/Tools/MeshModify.js";
import {Tool_PathModify, ToolState_PathModify} from "../../../UI/Maps/MapUI/Toolbox/Tools/PathModify.js";
import {Tool_None, ToolState_None} from "../../../UI/Maps/MapUI/Toolbox/Tools/None.js";
import {Tool_Measure, ToolState_Measure} from "../../../UI/Maps/MapUI/Toolbox/Tools/Measure.js";
import {Tool_Resize, ToolState_Resize} from "../../../UI/Maps/MapUI/Toolbox/Tools/Resize.js";
import {Tool_Pan, ToolState_Pan} from "../../../UI/Maps/MapUI/Toolbox/Tools/Pan.js";
import {ignore} from "mobx-sync";

export function ActiveMapTool() {
	const state = store.main.maps.tools;
	return state.ActiveTool();
}

export class MapToolsState {
	@O accessor activeTool = MapTool.none;
	@O accessor toolStates = new MapToolStates();

	// @ignore needed, because apparently mobx-sync synchronizes not-marked-observable props as well
	@ignore accessor tools = new MapTools();
	ActiveTool() {
		return this.tools[this.activeTool] as Tool|n;
	}

	@O accessor propertyPanelStates = new PropertyPanelStates();
}

export class MapTools {
	[MapTool.none] = new Tool_None();
	[MapTool.pan] = new Tool_Pan();
	[MapTool.select] = new Tool_Select();
	[MapTool.measure] = new Tool_Measure();
	[MapTool.cursor] = new Tool_Cursor();
	[MapTool.addObject] = new Tool_AddObject();
	[MapTool.move] = new Tool_Move();
	[MapTool.resize] = new Tool_Resize();
	[MapTool.meshModify] = new Tool_MeshModify();
	[MapTool.pathModify] = new Tool_PathModify();
}

export class MapToolStates {
	@O accessor none = new ToolState_None();
	@O accessor pan = new ToolState_Pan();
	@O accessor select = new ToolState_Select();
	@O accessor measure = new ToolState_Measure();
	@O accessor cursor = new ToolState_Cursor();
	@O accessor addObject = new ToolState_AddObject();
	@O accessor move = new ToolState_Move();
	@O accessor resize = new ToolState_Resize();
	@O accessor meshModify = new ToolState_MeshModify();
	@O accessor pathModify = new ToolState_PathModify();
}

export class PropertyPanelStates {
	@O accessor general = new Properties_GeneralState();
}
export class Properties_GeneralState {
	@O accessor snapOriginToCursor_pinMeshes = true;
	@O accessor snapOriginToCursor_pinPaths = true;
	@O accessor snapOriginToCursor_pinChildren = true;
}